import posthog from "posthog-js";
import { useEffect } from "react";

/**
 * Pauses PostHog session recording while the component is mounted.
 * Resumes recording on unmount. Useful for pages with Stripe iframes
 * where PostHog's DOM mutation observers cause performance issues.
 */
export function usePausePosthog() {
	useEffect(() => {
		posthog.stopSessionRecording();

		return () => {
			posthog.startSessionRecording();
		};
	}, []);
}
